import React from "react";
import { Form, Row, Col } from "antd";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";
import ControlledTreeSelect from "../../components/Backoffice/ControlledTreeSelect";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import { ImageUpload } from "../../components/Backoffice/ImageUpload";

const AddPackageForm = ({
  control,
  options = {},
  watch,
  errors,
  isCompanyAdmin,
  loading = {},
}) => {
  const { companies = [], catalog = [], commodities = [] } = options;
  const {
    companies: companiesLoading = false,
    commodities: commoditiesLoading = false,
    tests: testsLoading = false,
  } = loading;
  const variantOptions = [
    {
      label: "Normal",
      value: "Normal",
    },
    {
      label: "Organic",
      value: "Organic",
    },
    {
      label: "Loose",
      value: "Loose",
    },
  ];

  const selectedCopmany = watch("company");

  return (
    <Form colon={false}>
      {!isCompanyAdmin ? (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledSelect
              required
              control={control}
              name="company"
              label="Select Company"
              options={companies}
              errors={errors}
              loading={companiesLoading}
            />
          </Col>
        </Row>
      ) : (
        ""
      )}

      {selectedCopmany ? (
        <div>
          <Row gutter={24}>
            <Col span={24}>
              <ControlledSelect
                required
                control={control}
                name="commodity"
                label="Select Commodity"
                options={commodities}
                errors={errors}
                loading={commoditiesLoading}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="name"
                label="Package Name"
                errors={errors}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              {/*   <ControlledInput
                required
                control={control}
                name="sampleVariant"
                label="Sample Variant"
                errors={errors}
              /> */}
              <ControlledSelect
                required
                control={control}
                name="sampleVariant"
                label="Select Variant"
                options={variantOptions}
                errors={errors}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <ControlledTreeSelect
                required
                control={control}
                name="tests"
                label="Select Test Parameters"
                options={catalog}
                errors={errors}
                loading={testsLoading}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <ControlledSelect
                required
                control={control}
                name="isDefaultPackage"
                label="Is Default Package?"
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
                errors={errors}
              />
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              <ImageUpload
                control={control}
                name="image"
                label="Upload Package Image"
                errors={errors}
                acceptType={["image/*"]}
                maxCount={1}
              />
            </Col>
          </Row>
        </div>
      ) : (
        ""
      )}
    </Form>
  );
};

export default AddPackageForm;
